<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="administrators"
            v-if="users.length"
            :items="users"
            :fields="adminUsersFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-admin-users"
                    v-b-modal="'add-user-modal'"
                    v-if="groupIn.permissions.can_edit_permissions"
                    variant="primary">
                    {{ $t('group.settings.add_administrator') }}
                </b-button>
            </template>
            <template v-slot:cell(pivot.can_edit_permissions)="data">
                <b-form-checkbox
                    v-model="data.item.pivot.can_edit_permissions"
                    v-if="data.item.id !== $authUser.id"
                    switch
                    :disabled="!groupIn.permissions.can_edit_permissions"
                    :value="1"
                    @change="updateCoordinators"
                    :unchecked-value="0">
                </b-form-checkbox>
            </template>
            <template v-slot:cell(pivot.can_edit_portfolio)="data">
                <b-form-checkbox
                    v-model="data.item.pivot.can_edit_portfolio"
                    switch
                    :disabled="!groupIn.permissions.can_edit_permissions"
                    :value="1"
                    @change="updateCoordinators"
                    :unchecked-value="0">
                </b-form-checkbox>
            </template>

            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-remove btn-remove-admin-user"
                    v-if="data.item.id !== $authUser.id"
                    variant="danger-icon-only"
                    @click="removeUser(data.item.id)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="not-found with-header empty-admin-users-list"
            v-else>
            <div
                class="btn-add-circle icon"
                v-b-modal="'add-user-modal'"></div>

            <div class="alert-notice">{{ $t('group.settings.no_administrators_linked') }}</div>
        </div>

        <design-2021-group-show-add-user-modal-component
            :group-id="groupIn.id"
            @user-added="addUser($event)"
            ref="group-show-add-modal-component">
        </design-2021-group-show-add-user-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-admin-component',
    props: ['groupIn'],
    data() {
        return {
            users: this.groupIn.users,
        };
    },
    computed: {
        adminUsersFields() {
            let fields = [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                },
                {
                    key: 'pivot.can_edit_permissions',
                    label: this.$t('group.create.can_authorize_teachers'),
                },
            ];

            if (this.groupIn.portfolios.length) {
                fields.push({
                    key: 'pivot.can_edit_portfolio',
                    label: this.$t('group.create.can_edit_assignments'),
                });
            }
            if (this.groupIn.permissions.can_edit_permissions) {
                fields.push({
                    key: 'action',
                    label: this.$t('common.actions'),
                });
            }

            return fields;
        },
    },
    methods: {
        addUser(user) {
            user.pivot = {
                can_edit_permissions: 0,
                can_edit_portfolio: 0,
            };
            this.users.push(user);
            this.updateCoordinators();
        },
        updateCoordinators() {
            let data = this.users.map((user) => {
                return {
                    id: user.id,
                    can_edit_permissions: user.pivot.can_edit_permissions,
                    can_edit_portfolio: user.pivot.can_edit_portfolio,
                };
            });

            this.axios.post(this.routes.groupUpdateCoordinators(this.groupIn.id), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        removeUser(id) {
            this.alert
                .confirm(
                    this.$t('group.settings.delete_administrator'),
                    this.$t('group.settings.are_you_sure_this_user_no_longer_needs_to_be_an_administrator'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        this.users = this.users.filter((item) => item.id !== id);
                        this.updateCoordinators();
                        this.alert.success();
                    }
                });
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .administrators {
    .apprentice-table-header {
        .apprentice-data-table-actions {
            margin-top: map-get($grid-gutter-spacing, 'ten');
        }
    }
}

.btn-user-selection-toggle {
    color: grayscale(var(--primary));

    &.active {
        color: var(--primary);
    }
}

.empty-admin-users-list {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .icon {
        &:before {
            margin-right: 0;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    ::v-deep .administrators {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-data-table-actions,
            .apprentice-table-filters {
                flex: 0 0 auto;
                margin-bottom: 0;
            }

            .apprentice-data-table-actions {
                margin-left: auto;
                margin-top: 0;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    ::v-deep .administrators {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters,
            .apprentice-data-table-actions {
                flex: 0 0 auto;
            }

            .apprentice-data-table-actions {
                margin-top: 0;
            }
        }
    }
}
</style>
